import { Box, Flex, Heading, Tabs, Tab, TabList } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';

const tabIndexes = {
  manage: 0,
  history: 1,
};

export const FundingRequestsViewTemplate = ({
  fundingRequestId,
  children,
  isCreditFacilitySelectDisabled,
  selectedTab,
}: {
  fundingRequestId: string;
  isCreditFacilitySelectDisabled: boolean;
  children: React.ReactChild | React.ReactChild[];
  selectedTab: 'manage' | 'history';
}) => {
  const navigate = useNavigate();
  const { user } = useUserAuthOrThrow();
  return (
    <>
      <Flex justify="space-between">
        <Heading as="h2">Funding Request</Heading>

        <Box>
          <CreditFacilitySelect
            isDisabled={isCreditFacilitySelectDisabled}
            organizationId={user.organizationId}
          />
        </Box>
      </Flex>
      <Tabs variant="line" index={tabIndexes[selectedTab]} colorScheme="black">
        <TabList>
          <Tab
            onClick={() => navigate(`/funding-requests/${fundingRequestId}`)}
          >
            Submit Funding Request
          </Tab>
          <Tab onClick={() => navigate('/funding-requests/history')}>
            History
          </Tab>
        </TabList>
      </Tabs>
      <Box mt="25px" padding="10px">
        {children}
      </Box>
    </>
  );
};
